var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"book-gallery",attrs:{"name":"book-card-fade","tag":"div"}},_vm._l((_vm.books),function(book){return _c('book-card',_vm._b({key:book.id,staticClass:"book-gallery__item"},'book-card',book,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }